/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import {AccountEmailChangeService, ApiError} from '../../generated/iam-client';
import {from, Observable} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {of} from 'rxjs/internal/observable/of';
import {
	iamApiAccountEmailChangeStateRetrieved,
	iamApiRetrieveAccountEmailChangeStateNotFound,
	iamApiRetrieveAccountEmailChangeStateUnexpectedError
} from './actions';
import {AnyAction} from 'redux';

class AccountEmailChangeResource {

	accountEmailChangeState(attemptId: string): Observable<AnyAction> {
		const promise = AccountEmailChangeService.accountEmailChangeState(attemptId);

		return from(promise)
			.pipe(
				map((responseBody) => iamApiAccountEmailChangeStateRetrieved({state: responseBody})),
				catchError((error: ApiError) => {
					switch (error.status) {
						case 404:
							return of(iamApiRetrieveAccountEmailChangeStateNotFound());
						default:
							return of(iamApiRetrieveAccountEmailChangeStateUnexpectedError());
					}
				})
			);
	}
}

export default AccountEmailChangeResource;
